export { useCriticalErrorDisplayAnalytics } from './use-critical-error-display-analytics';
